import { render, staticRenderFns } from "./header-languages.vue?vue&type=template&id=1a77f879&scoped=true"
import script from "./header-languages.vue?vue&type=script&lang=js"
export * from "./header-languages.vue?vue&type=script&lang=js"
import style0 from "./header-languages.vue?vue&type=style&index=0&id=1a77f879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77f879",
  null
  
)

export default component.exports